<template>
    <ValidationObserver v-slot="{ handleSubmit }" v-if="campaign">
        <form @submit.prevent="handleSubmit(onSubmit)">
            <div class="p-5">
                <div
                    class="d-flex justify-content-between align-items-center mb-4"
                >
                    <div class="c-title">
                        Designations - {{ campaign.title }}
                    </div>

                    <div class="ml-auto">
                        <RouterLink class="ml-3" :to="`/campaigns/view/${$route.params.id}`">
                            <button class="btn c-cancel-btn">Back</button>
                        </RouterLink>
                    </div>

                    <button type="submit" class="btn ml-3 c-save-btn" v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_DESIGNATION_EDIT)">
                        Save
                    </button>
                </div>

                <div class="row">
                    <div class="col-7">
                        <div class="designation-items" v-if="designations.length">
                            <draggable handle=".sort-item" v-model="designations">
                                <div v-for="(item, index) in designations" :key="item.designation_id" :class="{'sort-item': DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_DESIGNATION_EDIT)}">
                                    <TextField
                                        v-model="item.name"
                                        name="sub_title"
                                            rules="required"
                                            readonly
                                            class-wrapper="designation-item"
                                    >
                                        <template #prepend-icon>
                                            <a style="cursor: move">
                                                <img src="~@/assets/images/drag-icon.svg"
                                                     alt="">
                                            </a>
                                        </template>
                                        <template #append-icon v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_DESIGNATION_EDIT)">
                                            <div class="designation-append d-flex flex-row justify-content-between">
                                                <div class="designation-default-label" v-if="index === 0">
                                                    <span>Default</span>
                                                </div>
                                                <div class="dropdown-btn" @click="showItemAction(item)">
                                                    <a>
                                                        <img src="~@/assets/images/blue-bar.svg"
                                                             alt="">
                                                    </a>
                                                    <div v-if="item.showAction" class="dropdown-menu"
                                                         :class="item.showAction ? 'active' : ''"
                                                         style="left: 30px; top: 15px; z-index: 99999"
                                                         v-click-outside="
                                                            () => {
                                                                    hideAction();
                                                                }
                                                            "
                                                    >
                                                        <a class="dropdown-item"
                                                           href="javascript:;"
                                                           @click="makeDefault(item.designation_id)"
                                                           v-text="'Make Default'"></a>
                                                        <a class="dropdown-item"
                                                           href="javascript:;"
                                                           @click="removeItem(item.designation_id)"
                                                           v-text="'Remove'"></a>
                                                    </div>
                                                </div>

                                            </div>

                                        </template>
                                    </TextField>
                                </div>
                            </draggable>
                        </div>
                        <div v-else class="no-designation-item mb-5">
                            <p>
                                No designations were set for the campaign.
                            </p>
                            <p>
                                Click the + button to add a designations.
                            </p>
                        </div>
                        <div v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_DESIGNATION_ADD)">
                            <a href="javascript:;" class="btn c-btn-add" @click="showAddDesignationModal">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>

                    <div class="col-5">

                    </div>
                </div>
            </div>
        </form>

        <modal-add-campaign-designation
            :items="designations"
            v-if="isShowAddDesignationModal"
            @close="isShowAddDesignationModal = false"
            @add="setDesignationItems" />
    </ValidationObserver>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import draggable from 'vuedraggable';
import ModalAddCampaignDesignation from "@/components/campaigns/components/ModalAddCampaignDesignation.vue";
import DibbleJS from "@/dibble";
import Authorizations from "@/utils/authorizations";

export default {
    name: 'CampaignDesignations',
    computed: {
        Authorizations() {
            return Authorizations
        },
        DibbleJS() {
            return DibbleJS
        }
    },
    components: {
        ModalAddCampaignDesignation,
        TextField,
        draggable,
    },
    data() {
        return {
            toggleActiveButton: false,
            toggleActionButton: false,
            isShowAddDesignationModal: false,
            designations: [],
            campaign: null,
        };
    },
    methods: {
        showAddDesignationModal() {
            this.isShowAddDesignationModal = true;
        },
        onSubmit() {
            const designations = [];
            this.designations.forEach((item) => {
                designations.push({
                    designation_id: item.designation_id,
                });
            });

            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.campaignSetDesignations,
                campaign_id: this.$route.params.id,
                designations: designations,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJs.toastSuccessMessage('Designations updated successfully.');
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        getCampaign() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.getCampaign,
                campaign_id: this.$route.params.id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.campaign = response;
                    if (response.designations.length) {
                        response.designations.forEach((item) => {
                            this.designations.push({
                                designation_id: item.id,
                                name: item.name,
                                showAction: false,
                            });
                        })
                    }
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        removeItem(id) {
            this.designations = this.designations.filter((item) => {
                return item.designation_id !== id;
            });
        },
        setDesignationItems(items) {
            this.isShowAddDesignationModal = false;
            if (!items.length) {
                this.designations = [];
                return;
            }

            const results = [];
            this.designations.forEach((item) => {
                const dataItem = items.find((x) => x.designation_id === item.designation_id);
                if (dataItem) {
                    results.push({
                        designation_id: dataItem.designation_id,
                        name: dataItem.name,
                        showAction: false,
                    });
                }
            });

            items.forEach((item) => {
                const dataItem = this.designations.find((x) => x.designation_id === item.designation_id);
                if (!dataItem) {
                    results.push({
                        designation_id: item.designation_id,
                        name: item.name,
                        showAction: false,
                    });
                }
            });

            this.designations = [];
            this.designations = results;
        },
        showItemAction(item) {
            const designations = this.designations;
            const index = designations.findIndex((x) => x.designation_id === item.designation_id);
            const isOpened = designations[index].showAction;

            designations.forEach((item, index) => {
                designations[index].showAction = false;
            });

            if (!isOpened)
                designations[index].showAction = true;
            else
                designations[index].showAction = false;

            this.designations = [];
            this.designations = designations;
        },
        hideAction() {
            const designations = this.designations;
            designations.forEach((item, index) => {
                designations[index].showAction = false;
            });
            this.designations = [];
            this.designations = designations;
        },
        makeDefault(id) {
            const designations = this.designations;
            const item = designations.find((x) => x.designation_id === id);
            this.designations = [];
            this.designations.push(item);

            this.designations = this.designations.concat(designations.filter((x) => x.designation_id !== id));
        },
    },
    created() {
        this.getCampaign();
    },
};
</script>

<style lang="scss" scoped>
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}

.c-cancel-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}

.c-donations-btn, .c-distribution-btn {
    border-radius: 20px;
    background: #6CA779;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 140px;
    color: #fff;
    line-height: 140%;
}

.c-distribution-btn {
    background: #7BBDEF;
    color: #555E67 !important;
    width: 160px;
}

.c-save-btn {
    border-radius: 20px;
    background: #2178ab;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    width: 120px;
    line-height: 140%;
}

.c-label {
    font-size: 20px;
    line-height: 24px;
    color: #555e67;
    margin-top: 33px;
    margin-bottom: 33px;
}

.c-upload {
    background-color: #e1e7e9;
    border-radius: 20px;
    padding: 24px 32px;
}

.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    margin-bottom: 28px;
}

.dropdown-btn {
    position: relative;

    span {
        display: block;

        &.top {
            font-size: 12px;
            line-height: 16px;
            color: #555E67;
        }
    }

    .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
        min-width: 10rem;
        text-align: left;
        list-style: none;

        background-clip: padding-box;
        border: none;
        border-radius: 30px;
        width: 275px;
        background: none;

        &.active {
            display: block;
        }

        .dropdown-item {
            color: #555E67;
            font-size: 20px;
            font-weight: 700;
            background-color: #EDF5F7;
            padding: 12px 35px;
            border-bottom: 1px solid #DEE6EA;

            &:first-child {
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
            }

            &:last-child {
                border-bottom-left-radius: 30px;
                border-bottom-right-radius: 30px;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
            }

            &:hover {
                background-color: #bae3ef;
                color: #2178AB;
            }
        }
    }
}
.designation-item {
    input {
        color: #555E67 !important;
    }
}
.designation-append {
    .designation-default-label {
        border-radius: 20px;
        padding: 5px 10px;
        font-size: 12px;
        line-height: 16px;
        color: #7C7C7A;
        border: 1px solid #7C7C7A;
        font-weight: 500;
        margin-right: 10px;
    }
}
.c-btn-add {
    color: #fff;
    width: 61px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 24px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.no-designation-item {
    font-size: 18px !important;
    color: #000000 !important;
    line-height: 160% !important;
    font-weight: 600 !important;
}
</style>
